/* Native HTML backfill only when a collection outgrows Shopify's initial 50-item batch.
   Normal-size rows are server-rendered and make no backfill requests. */
(function () {
  'use strict';
  async function collectNativeCards(firstUrl, handle, getPage) {
    const seenPages = new Set();
    const seenProducts = new Set();
    const cards = [];
    let url = firstUrl;
    while (url && cards.length < 4) {
      if (seenPages.has(url)) throw new Error('Repeated native pagination URL');
      seenPages.add(url);
      const page = await getPage(url);
      if (page.handle !== handle) throw new Error('Unexpected beaded collection');
      for (const card of page.cards) {
        if (!card.id || seenProducts.has(card.id)) continue;
        seenProducts.add(card.id);
        cards.push(card);
        if (cards.length === 4) break;
      }
      url = page.next;
    }
    return cards;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { collectNativeCards };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__anFeaturedBeadedBackfill) return;
  window.__anFeaturedBeadedBackfill = true;

  function attachNativeShadowRoots(root) {
    root.querySelectorAll('template[shadowrootmode="open"]').forEach(function (template) {
      const host = template.parentElement;
      if (host && !host.shadowRoot) {
        host.attachShadow({ mode: 'open' }).appendChild(template.content);
        template.remove();
      }
    });
  }
  async function backfill(source) {
    if (source.dataset.backfillStarted === 'true') return;
    source.dataset.backfillStarted = 'true';
    const handle = source.dataset.collectionHandle;
    if (!['beaded-hey-dudes', 'beaded-flat-brim-hats'].includes(handle)) return;
    const base = new URL(source.dataset.collectionUrl, window.location.origin);
    const sectionId = source.dataset.sourceSectionId;
    const first = new URL(base);
    first.searchParams.set('section_id', sectionId);
    let rowTemplate = null;
    source.setAttribute('aria-busy', 'true');
    try {
      const cards = await collectNativeCards(first.href, handle, async function (pageUrl) {
        const url = new URL(pageUrl, base);
        if (url.origin !== base.origin || url.pathname !== base.pathname) throw new Error('Unexpected native pagination route');
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Native backfill request failed');
        // Trusted same-origin Shopify section HTML; never insert third-party or user-authored HTML.
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = parsed.querySelector('[data-an-beaded-feed]');
        if (!feed || feed.dataset.collectionHandle !== handle) throw new Error('Missing native beaded feed');
        const row = feed.querySelector('.an-beaded-row');
        if (row && !rowTemplate) rowTemplate = row;
        const next = feed.dataset.nextPage ? new URL(feed.dataset.nextPage, url).href : null;
        return { handle: handle, cards: Array.from(feed.querySelectorAll('article.an-beaded-row__card[data-product-id]')).map(function (card) { return { id: card.dataset.productId, node: card }; }), next: next };
      });
      if (cards.length && rowTemplate) {
        const row = document.importNode(rowTemplate, true);
        const grid = row.querySelector('.an-hp05__grid');
        grid.replaceChildren();
        cards.forEach(function (card) { grid.appendChild(document.importNode(card.node, true)); });
        row.querySelectorAll('script').forEach(function (script) { script.remove(); });
        attachNativeShadowRoots(row);
        source.replaceChildren(row);
      } else {
        source.replaceChildren();
      }
      source.dataset.backfillComplete = 'true';
    } catch (error) {
      // Preserve the valid native initial cards / collection link on network or rendering failure.
      source.dataset.backfillError = 'true';
    } finally {
      source.removeAttribute('aria-busy');
    }
  }
  function scan() {
    document.querySelectorAll('[data-an-beaded-source][data-needs-backfill="true"]').forEach(backfill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
}());
